/* lua.js generated code 0.3.0 */

require("clover/const/GamePropConst")
require("clover/data/ItemDataManager")
UserDealValidateFuncRef = table()
userDealValidate = function (goodsId, num) {
    var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    if (!goodsMeta) {
        return [false, ZooErrorCode.BUY_GOOODSID_INVAILD]
    }
    var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    if (topLevel < (goodsMeta.level || 0)) {
        return [false, ZooErrorCode.BUY_LEVEL_NOT_ENOUGH]
    }
    // FIXME: deal props
    //return [false, ZooErrorCode.BUY_LEVEL_NOT_ENOUGH]
    if (goodsMeta.limit > 0) {
        var bought = UserManager.getInstance().getDailyData().getBuyedGoodsNumber(goodsId)
        if (bought >= goodsMeta.limit || bought + num > goodsMeta.limit) {
            return [false, ZooErrorCode.BUY_LIMIT_GOODS_ERROR_OVER_LIMIT]
        }
    }
    if (type(UserDealValidateFuncRef[goodsId]) === "function") {
        var [success, errCode] = UserDealValidateFuncRef[goodsId](goodsId, num)
        if (!success) {
            return [success, errCode]
        }
    }
    return [true]
}
module.exports = userDealValidate
